export default (msg) => {
    console.log(msg);
}